import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";
import { generalFormConfig } from "./generalFormConfig";
import { textualFormConfig } from "./textualFormConfigs";

export const selectBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Form:Select",
  override: true,
  image:
    "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "options",
      type: "list",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          defaultValue: "Label",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          defaultValue: "Value",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
      ],
      defaultValue: [
        {
          label: "Option 1",
          value: "option-1",
        },
        {
          label: "Option 2",
          value: "option-2",
        },
      ],
    },
    {
      name: "value",
      type: "object",
      localized: false,
      helperText:
        "Single selection value. Leave empty for multiple selection mode.",
      showIf: (options) => options?.get("isMultipleSelection") !== true,
      subFields: [
        {
          name: "label",
          type: "string",
          defaultValue: "Label",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          defaultValue: "Value",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
      ],
      defaultValue: {
        label: "Option 1",
        value: "option-1",
      },
    },
    {
      name: "value",
      type: "list",
      localized: false,
      helperText: "Multiple selection values (array of selected options).",
      showIf: (options) => options?.get("isMultipleSelection") === true,
      subFields: [
        {
          name: "label",
          type: "string",
          defaultValue: "Label",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          defaultValue: "Value",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
      ],
      defaultValue: [],
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onInitialize",
      type: "javascript",
      localized: false,
    },
    {
      name: "onBlur",
      type: "javascript",
      localized: false,
    },
    {
      name: "isMultipleSelection",
      type: "boolean",
      defaultValue: false,
      localized: false,
    },
    {
      name: "multipleSelectionDisplayLabel",
      type: "string",
      localized: true,
      helperText: "Label to show when multiple options are selected.",
      showIf: (options) => options?.get("isMultipleSelection") === true,
    },
    {
      name: "formControlContainerClassName",
      type: "string",
      localized: false,
      helperText: "Tailwinds classnames for the form control container.",
    },
    ...(generalFormConfig ?? []),
    ...(textualFormConfig ?? []),
    { ...DLT_FIELD, required: false },
    { ...DLD_FIELD, required: false },
  ],
  defaultStyles: {
    width: "100%",
  },
};
